import bankCodes from '../bank-codes'

export default {
  'bank-codes': {
    ...bankCodes,
  },
  'bank': '@:terms.bank',
}
